<template>
    <div class="p-inputtext-sm">
        <div v-if="isIndividual">
            <DataTable :loading="isAssign ? !dataModel : !drivers" v-model:expandedRows="expandedRows" :value="!isAssign ? drivers : dataModel.driverModels " responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                <Column :expander="true" v-if="isAssign && assignMultiple">
                   <template #header="">
                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail"  />
                    </template>
                    <template #body="slotProps">
                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)"/>
                    </template>
                </Column>
                <Column field="Driver_Id" :header="$t('driver')" key="Driver_Id" class="w-4">
                    <template #body="slotProps">
                        <div  v-if="!isRelation && loaded && isAssign" >
                            <CustomSelect 
                                placeholder="Driver 1"
                                v-model="slotProps.data[slotProps.column.props.field]" 
                                :url="this.$API_URL + 'list/driver'" 
                                :minLength="0" 
                                :params="{ transporter_code: transporterCode, exclude_ids: excludeDrivers, location: locationCode, warehouse_code: warehouseCode,  check_driver: multipleWeighing ? 'N' : 'Y' }" 
                                :filter="true"
                                @change="onDriverChange($event, slotProps.data)"
                                :disabled="isRegisteredIn && mode == $FORM_MODE_EDIT"
                                />


                            <CustomSelect 
                                class="mt-1"
                                 placeholder="Driver 2"
                                v-model="slotProps.data.Replacement_Driver_Id" 
                                :url="this.$API_URL + 'list/driver'" 
                                :minLength="0" 
                                :params="{ transporter_code: transporterCode, exclude_ids: excludeDrivers(true), location: locationCode, warehouse_code: warehouseCode, check_driver: 'N' }" 
                                :filter="true"
                                @change="onDriverChange1($event, slotProps.data)"
                                v-if="multipleWeighing"
                                />

                        </div>
                       
                        <div v-else-if="isRelation && loaded && isAssign">
                            <InputText name="Driver_Id" type="text" v-model="slotProps.data['Driver_Name']" style="display:block" /> 
                            <InputText name="Driver_Id" type="text" v-model="slotProps.data['Replacement_Driver_Name']" style="display:block" class="mt-1"  v-if="multipleWeighing"/> 
                        </div>

                        <div v-else-if="!isAssign">
                            <InputText name="Driver_Id" type="text" v-model="slotProps.data['Driver_Name']" disabled style="display:block" /> 
                            <InputText name="Driver_Id" type="text" v-model="slotProps.data['Replacement_Driver_Name']" disabled style="display:block"  v-if="multipleWeighing"  class="mt-1"/> 
                        </div>
                    </template>  
                </Column>
                <Column field="License_No" :header="$t('license_no')" key="License_No" class="w-2">
                    <template #body="slotProps">
                        <div v-if="isRelation && loaded">
                            <InputText name="License_No" type="text" v-model="slotProps.data['License_No']" :disabled="!isRelation" style="display:block" /> 
                            <InputText name="Replacement_License_No" type="text" v-model="slotProps.data['Replacement_License_No']" :disabled="!isRelation"  v-if="multipleWeighing" style="display:block" class="mt-1" /> 
                        </div>

                        <div v-else-if="!isRelation">
                            <InputText name="License_No" type="text" v-model="slotProps.data['License_No']" disabled style="display:block" /> 
                            <InputText name="Replacement_License_No" type="text" v-model="slotProps.data['Replacement_License_No']" disabled style="display:block"  v-if="multipleWeighing" class="mt-1" /> 
                        </div>
                    </template>
                </Column>
                <Column field="Phone" :header="$t('phone')" key="phone" class="w-2">
                    <template #body="slotProps">
                        <div v-if="isRleation && loaded">
                            <InputText name="Phone" type="text" v-model="slotProps.data['Phone']" :disabled="!isRelation" style="display:block" /> 
                            <InputText name="Phone" type="text" v-model="slotProps.data['Replacement_Phone']" :disabled="!isRelation" style="display:block"  v-if="multipleWeighing" class="mt-1"/> 
                        </div>

                        <div v-else-if="!isRelation">
                            <InputText name="Driver_Id" type="text" v-model="slotProps.data['Phone']" disabled style="display:block" /> 
                            <InputText name="Driver_Id" type="text" v-model="slotProps.data['Replacement_Phone']" disabled style="display:block" class="mt-1" v-if="multipleWeighing" /> 
                        </div>
                    </template>
                </Column>
                <Column field="Vehicle_Id" :header="$t('vehicle_no')" key="Vehicle_No" class="w-2">
                    <template #body="slotProps">
                        <div v-if="!isRelation && loaded && isAssign">
                            <CustomSelect 
                                placeholder="Truck 1"
                                v-model="slotProps.data.Vehicle_Id" 
                                :url="this.$API_URL + 'list/vehicle'" 
                                :minLength="0" 
                                :filter="true"
                                :params="{ transporter_code: transporterCode, exclude_ids: excludeVehicles, location: locationCode, warehouse_code: warehouseCode, check_vehicle: multipleWeighing ? 'N' : 'Y' }" 
                                :disabled="isRegisteredIn && mode == $FORM_MODE_EDIT"
                                />

                            <CustomSelect 
                                class="mt-1"
                                placeholder="Truck 2"
                                v-model="slotProps.data.Replacement_Vehicle_Id" 
                                :url="this.$API_URL + 'list/vehicle'" 
                                :minLength="0" 
                                :filter="true"
                                :params="{ transporter_code: transporterCode, exclude_ids: excludeVehicles, location: locationCode, warehouse_code: warehouseCode, check_vehicle: 'N' }" 
                                 v-if="multipleWeighing"
                                />
                        </div>

                        <div v-else-if="isRelation && loaded && isAssign">
                            <InputText name="Driver_Id" type="text" v-model="slotProps.data['Vehicle_Name']" style="display:block" /> 
                            <InputText name="Driver_Id" type="text" v-model="slotProps.data['Replacement_Vehicle_Name']" style="display:block" class="mt-1"  v-if="multipleWeighing"/> 
                        </div>

                        <div v-else-if="!isAssign">
                            <InputText name="Driver_Id" type="text" v-model="slotProps.data['Vehicle_Name']" style="display:block"  disabled/> 
                            <InputText name="Driver_Id" type="text" v-model="slotProps.data['Replacement_Vehicle_Name']" style="display:block" class="mt-1" disabled  v-if="multipleWeighing"/> 

                        </div>
                    </template>
                </Column>
                <Column field="Container_No" :header="$t('container_no')" key="Container_No" class="w-2">
                    <template #body="slotProps">
                        <div v-if="loaded && isAssign">
                            <InputText name="Container_No" type="text" v-model="slotProps.data['Container_No']" style="display:block"/> 
                            <InputText name="Container_No" type="text" v-model="slotProps.data['Replacement_Container_No']" style="display:block" class="mt-1"  v-if="multipleWeighing"/> 
                        </div>

                        <div v-else-if="!isAssign">
                            <InputText name="Container_No" type="text" v-model="slotProps.data['Container_No']" style="display:block" disabled/> 
                            <InputText name="Container_No" type="text" v-model="slotProps.data['Replacement_Container_No']" style="display:block" class="mt-1" disabled  v-if="multipleWeighing"/> 
                        </div>
                    </template>
                </Column>
                <template #expansion="slotProps">
                    <div class="orders-subtable" style="margin-left:2vw">
                        <DataTable :value="slotProps.data.materials" class="w-screen-5">
                            <Column field="Item_No" :header="$t('item_no')" class="w-1"></Column>
                            <Column field="sap_no" :header="$t('sap_no')" v-if="isMerge" class="w-2">
                            </Column>
                            <Column field="order_no" :header="$t('order_no')" v-if="isMerge" class="w-2">
                            </Column>
                            <Column field="Material_Name" :header="$t('material_name')" :class="isMerge ? 'w-4' : 'w-6'"></Column>
                            <Column field="Qty" :header="$t('qty')">
                                <template #body="slotProps1">
                                    <InputNumber v-model="slotProps1.data[slotProps1.column.props.field]" mode="decimal" :optionalDecimal="true" :max="materialMaxQty(slotProps, slotProps1)" :disabled="disableQtyInput"/>
                                </template>
                            </Column>
                            <Column field="UOM" :header="$t('uom')"></Column>
                        </DataTable>
                    </div>
                </template>
            </DataTable>
        </div>
        <div v-else-if="isCollective">
            <DataTable :loading="!dataModel.driverModels" :value="dataModel.driverModels" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table" :rowClass="hideRow">
                 <Column :exportable="false" bodyStyle="width:30px">
                    <template #header="">
                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail" />
                    </template>
                    <template #body="slotProps">
                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)" :disabled="isRegisteredIn && allowDelete(slotProps.data)" />
                    </template>
                </Column>
                <Column field="Driver_Id" :header="$t('driver')" key="driver_id">
                    <template #body="slotProps">
                        <div class="p-fluid">
                            <CustomSelect 
                                v-if="!isRelation && loaded" 
                                v-model="slotProps.data[slotProps.column.props.field]" 
                                :url="this.$API_URL + 'list/driver'" 
                                :minLength="0" 
                                :params="{ transporter_code: transporterCode, exclude_ids: excludeDrivers, location: locationCode, warehouse_code: warehouseCode }" 
                                :filter="true"
                                @change="onDriverChange($event, slotProps.data)"
                                :disabled="isRegisteredIn && allowDelete(slotProps.data)"
                                />
                        </div>
                    </template>
                </Column>
                <Column field="License_No" :header="$t('license_no')" key="license_no">
                    <template #body="slotProps">
                        <div class="p-fluid">
                            <span>{{slotProps.data['License_No']}}</span>
                        </div>
                    </template>
                </Column>
                <Column field="Phone" :header="$t('phone')" key="phone">
                    <template #body="slotProps">
                        <div class="p-fluid">
                            <span>{{slotProps.data['Phone']}}</span>
                        </div>
                    </template>
                </Column>
                
                <Column field="Vehicle_Id" :header="$t('vehicle_no')" key="vehicle_id">
                    <template #body="slotProps">
                        <div class="p-fluid">
                            <CustomSelect 
                                v-if="!isRelation && loaded" 
                                v-model="slotProps.data[slotProps.column.props.field]" 
                                :url="this.$API_URL + 'list/vehicle'" 
                                :minLength="0" 
                                :filter="true"
                                :params="{ transporter_code: transporterCode, exclude_ids: excludeVehicles, location: locationCode, warehouse_code: warehouseCode }" 
                                :disabled="isRegisteredIn && allowDelete(slotProps.data)"
                                />
                        </div>
                    </template>
                </Column>
                <Column field="Container_No" :header="$t('container_no')" key="Container_No">
                    <template #body="slotProps">
                        <InputText name="Container_No" type="text" v-model="slotProps.data['Container_No']" v-if="loaded"/> \
                    </template>
                </Column>
                <Column field="Invalid" :header="$t('invalid')" key="Invalid">
                    <template #body="slotProps">
                        <div class="p-fluid">
                            <Checkbox v-model="slotProps.data.Invalid" :binary="true" :disabled="true" :readonly="true"/>
                        </div>        
                    </template>
                </Column>
                <Column field="Invalid_Date" :header="$t('invalid_date')" key="Invalid">
                    <template #body="slotProps">
                        <div class="p-fluid">
                            {{this.$formatDateTime(slotProps.data.Invalid_Date)}}
                        </div>        
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>
</template>
<script>
    export default{
        props:{
            isIndividual: {
                type: Boolean,
                default: false
            },
            isCollective: {
                type: Boolean,
                default: false
            },
            isRelation: {
                type: Boolean,
                default: false
            },
            transporterCode:{
                type:String,
                default:""
            },
            locationCode:{
                type:String,
                default:""
            },
            materials:{
                type:Array,
                default: function () { return [] }
            },
            isMerge:{
                type: Boolean,
                default: false
            },
            isAssign: {
                type: Boolean,
                default: true
            },
            assignMultiple:{
                type: Boolean,
                default: true
            },
            drivers:{
                type:Array,
                default: []
            },
            dataModel:{
                type:Object,
                default:null
            },
            isRegisteredIn:{
                type:Boolean,
                default:false
            },
            useLN:{
                type:Boolean,
                default: false
            },
            warehouseCode:{
                type:String,
                default: ""
            },
            disableEditQtyIndividualTruck:{
                type:Boolean, 
                default: false
            },
            multipleWeighing:{
                type:Boolean,
                default:false
            },
            mode:{
                type: String,
                default: ""
            },
            lockEditDriver:{
                type:Boolean,
                default:false
            }
        },
        data(){
            return {
                transporter: "",
                location: "",
                expandedRows:[],
            }
        },
        mounted(){
            if(this.isIndividual && this.isAssign && this.dataModel.driverModels.length == 0)
                    this.addDetail();
        },
        methods:{
            addDetail() {
                var newDetail = this.dataModel.driverModel;
                newDetail.mode = this.$FORM_MODE_CREATE;
                var det = { ...newDetail };
                det.materials = [];

                for(var i=0; i< this.materials.length;i++){
                    var newMaterial = this.materials[i];
                    var materialDet = { ...newMaterial};
                    materialDet.Qty = 0;
                    det.materials.push(materialDet);
                }

                this.expandedRows.push(det);
                this.dataModel.driverModels.push(det);
                
            },
            deleteDetail(event) {
                if (event) {
                    var detail = null;
                    var details = null;

                    if(this.isAssign){
                        details = this.dataModel.driverModels;
                    }
                    else{
                        detail = this.drivers;
                    }

                    detail = details[event.index];

                    if (detail.mode == this.$FORM_MODE_CREATE) details.splice(details.indexOf(detail), 1);
                    else detail.mode = this.$FORM_MODE_DELETE;
                }
            },
            materialMaxQty(parent, event){
                //set to :max
                var isMerge = this.isMerge;

                var materialCode = event.data.Material_Code;
                var detailId = event.data.Id;
                var maxQty = this.materials.filter(r=> {
                                    return r.Id == detailId
                                }) 
                                .reduce(function(tot, arr) {
                                    return tot + arr.os_qty;
                                },0); 

                var sumQty = 0;

                for(var i=0;i< this.dataModel.driverModels.length;i++){
                    if(i == parent.index) continue;

                    if(this.dataModel.driverModels[i].materials == null) continue;

                    sumQty += this.dataModel.driverModels[i].materials
                                .filter(r => {
                                    return r.Id == detailId
                                })
                                .reduce(function(tot, arr) {
                                    return tot + arr.Qty;
                                },0);   
                }

                return maxQty - sumQty;
            },
            onDriverChange(event, data){
                //console.log(event);
                if(data.mode == this.$FORM_MODE_UNCHANGED)
                    data.mode = this.$FORM_MODE_EDIT;
                data.License_No = event.license;
                data.Phone = event.phone;
            },
            onDriverChange1(event, data){
                //console.log(event);
                if(data.mode == this.$FORM_MODE_UNCHANGED)
                    data.mode = this.$FORM_MODE_EDIT;
                data.Replacement_License_No = event.license;
                data.Replacement_Phone = event.phone;
            },
            hideRow(data) {
                return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
            },
            allowDelete(data){
                return data.mode != this.$FORM_MODE_CREATE;
            },
            excludeDrivers(excludeOptional){
                // if(this.isIndividual)
                // {
                //     var vehicles = "";
                //     if(this.dataModel.driverModels.length > 0){
                //         var allIds = this.dataModel.driverModels.map(function(v) {
                //             return v.Driver_Id;
                //         });
                //         vehicles = allIds.join(";");
                //     }

                //     return vehicles;   
                // }
                // else
                // {
                //     return "";
                // }

                var self = this;
                var drivers = "";
                if(this.dataModel.driverModels.length > 0){
                    var driverIds = [];

                    this.dataModel.driverModels.forEach(function(v) {
                        var addToList = false;
                        
                        if(self.isCollective){
                            addToList = false;
                        }
                        else{
                            if(v.mode == self.$FORM_MODE_CREATE){
                                addToList = true;
                            }
                        }

                        if(excludeOptional)
                            addToList = false;

                        if(addToList){
                            if(v.Driver_Id && v.Driver_Id != 0)
                            {
                                driverIds.push(v.Driver_Id);
                            }

                            // if(v.Replacement_Driver_Id && v.Replacement_Driver_Id != 0){
                            //     driverIds.push(v.Replacement_Driver_Id);
                            // }


                        }
                    });
                    drivers = driverIds.join(";");
                }

                return drivers;   
            },
            excludeVehicles(excludeOptional){
                // if(this.isIndividual)
                // {
                //     var vehicles = "";
                //     if(this.dataModel.driverModels.length > 0){
                //         var allIds = this.dataModel.driverModels.map(function(v) {
                //             return v.Vehicle_Id;
                //         });
                //         vehicles = allIds.join(";");
                //     }

                //     return vehicles;
                // }
                // else
                // {
                //     return "";
                // }

                var self = this;
                var vehicles = "";
                // if(this.dataModel.driverModels.length > 0){
                //     var allIds = this.dataModel.driverModels.map(function(v) {
                //         return v.Vehicle_Id;
                //     });
                //     vehicles = allIds.join(";");
                // }

                if(this.dataModel.driverModels.length > 0){
                    var vehicleIds = [];

                    
                    this.dataModel.driverModels.forEach(function(v) {
                        var addToList = false;
                        
                        if(self.isCollective){
                            addToList = false;
                        }
                        else{
                            if(v.mode == self.$FORM_MODE_CREATE){
                                addToList = true;
                            }
                        }

                        if(excludeOptional)
                            addToList = false;

                        if(addToList){
                            if(v.Vehicle_Id && v.Vehicle_Id != 0)
                            {
                                vehicleIds.push(v.Vehicle_Id);
                            }

                            // if(v.Replacement_Vehicle_Id && v.Replacement_Vehicle_Id != 0){
                            //     vehicleIds.push(v.Replacement_Driver_Id);
                            // }
                        }
                    });
                    vehicles = vehicleIds.join(";");
                }

                return vehicles;
            },
            
        },
        computed:{
            disableQtyInput(){
                return this.isCollective || this.useLN || this.disableEditQtyIndividualTruck;
            },
            loaded(){
                return this.dataModel != null &&this.dataModel.driverModels != null && this.dataModel.driverModels.length > 0;
            },
            
        }
    }
</script>